export default "__VITE_ASSET__BxW7lVpb__"